<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import RegisterView from '../../auth/components/RegisterView.vue'

// Not ready for release: registration is only open in development builds
definePage({
    meta: {
        isGuest: true,
        devOnly: true,
    }
})
</script>

<template>
  <RegisterView />
</template>